import * as types from "../constants/actionTypes";

export const googleMapsInitialState = {
    selectedMarker: null,
    showMapModalWindow: false,
    closeMapInfoWindow: true,
    selectedItem: null,
    currentLocationZipCode:null
};

export default function mapEventsReducer(state = googleMapsInitialState, action) {
    switch (action.type) {
        case types.MAP__OPEN_MODAL_WINDOW:
            return { ...state, selectedMarker: action.payload.selectedItem, selectedItem: action.payload.selectedItem, showMapModalWindow: true, closeMapInfoWindow:false };
        case types.MAP__CLOSE_MODAL_WINDOW:
            return { ...state, selectedMarker: null, showMapModalWindow: false, closeMapInfoWindow : true };
        case types.MAP__CLOSE_INFO_WINDOW:
            return { ...state, selectedMarker: null, showMapModalWindow: false, closeMapInfoWindow: true };
        case types.RESET_SELECTED_MAPS_VALUE:
            return { ...state, selectedMarker: null, selectedItem: null, showMapModalWindow: false, closeMapInfoWindow: true };
        case types.CURRENT_LOCATION_ZIPCODE:
            return { ...state, currentLocationZipCode: action.payload.currentLocationZipCode };
        default:
            return { ...state };
    }
}